/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Playground_UnavailableInputs */

const vi_dev_playground_unavailable = /** @type {(inputs: Dev_Playground_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng này chưa khả dụng.`)
};

/**

* @param {Dev_Playground_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dev_playground_unavailable = /** @type {((inputs?: Dev_Playground_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Playground_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dev_playground_unavailable(inputs)
});